import clsx from 'clsx'

import styles from './CoffeeBullet.module.scss'

interface CoffeeBulletProps {
  full: boolean
  large?: boolean
}

export const CoffeeBullet = ({ full, large }: CoffeeBulletProps) => (
  <div className={clsx(styles.bullet, full && styles.full, large && styles.large)} />
)
